import presetRecipients from 'constants/presetRecipients';
import { RecipientSourceOption } from '../types/RecipientSourceOption';

export const recipientSources: RecipientSourceOption[] = [
  {
    id: 'source-partners',
    value: presetRecipients.PARTNERS,
    label: 'Partners',
  },
  {
    id: 'source-beneficiaries',
    value: presetRecipients.BENEFICIARIES,
    label: 'Beneficiaries',
    disabled: true,
  },
  {
    id: 'source-investors',
    value: presetRecipients.INVESTORS,
    label: 'InvestorsConvertibleNote',
    disabled: true,
  },
  {
    id: 'source-directors',
    value: presetRecipients.DIRECTORS,
    label: 'AdminOrgan',
    disabled: true,
  },
];
